import { createV3Queries } from "@query/utils/createV3Queries";
import { workItemsApi } from "@api";
import { queriesWorkLogs } from "./queriesWorkLogs";
import { QUERY_LIST_RESOURCE_EVENTS } from "../../query/resourceEvents/queries/useQueryListEvents";

/**
 * Work-item registry — mirrors `WorkItemsApi` 1:1. The name-derived defaults
 * already refresh the sibling item reads (`getWorkItem` / `listWorkItems`); the
 * cross-resource configs below reproduce what the v1 mutation hooks invalidated:
 * a work-item change alters the parent work log's totals, so the work-log reads
 * (single + list, which also backs the work-log summary) must refetch, along
 * with the resource-events activity feed (still on v1 caches during coexistence).
 */
export const queriesWorkItems = createV3Queries("workItemsApi", workItemsApi, {
  createWorkItem: () => ({
    dependencies: [
      queriesWorkLogs.getWorkLog.queryKeyBase,
      queriesWorkLogs.listWorkLogs.queryKeyBase,
      QUERY_LIST_RESOURCE_EVENTS
    ]
  }),
  updateWorkItem: () => ({
    dependencies: [
      queriesWorkLogs.getWorkLog.queryKeyBase,
      queriesWorkLogs.listWorkLogs.queryKeyBase,
      QUERY_LIST_RESOURCE_EVENTS
    ]
  }),
  deleteWorkItem: () => ({
    dependencies: [
      queriesWorkLogs.getWorkLog.queryKeyBase,
      queriesWorkLogs.listWorkLogs.queryKeyBase,
      QUERY_LIST_RESOURCE_EVENTS
    ]
  })
});
